import { z } from 'zod';
const modelUsageTokensSchema = z.object({
    inputTokens: z.number().int().nonnegative().max(100_000_000),
    outputTokens: z.number().int().nonnegative().max(1_000_000),
    cacheReadInputTokens: z.number().int().nonnegative().max(100_000_000).optional(),
    cacheWriteInputTokens: z.number().int().nonnegative().max(100_000_000).optional(),
});
export const reserveModelUsageSchema = z
    .object({
    token: z.string().max(256),
    modelId: z.string().min(1).max(256),
    region: z.string().min(1).max(40),
    usage: modelUsageTokensSchema,
})
    .strict();
export const modelUsageReservationSchema = z.object({
    reservationId: z.uuid().nullable(),
});
export const settleModelUsageSchema = reserveModelUsageSchema.extend({
    reservationId: z.uuid(),
});
export const modelUsageReceiptSchema = z.object({ settled: z.literal(true) });
